import { Footer } from '../../components';
import { Container } from './styled';

export function Location(props) {


    const { message, className } = props;


    return (
        <Container
            className={className}
            isUserSystem={message?.user_system ? true : false}
        >
            <iframe
                title={'Location'}
                src={`https://www.google.com/maps?q=${message?.location.latitude},${message?.location.longitude}&z=17&hl=pt-BR&output=embed`}
            />
            <div className={`${!message?.body ? 'footer-styled' : ''}`}>
                <Footer message={message} />
            </div>
        </Container>
    )
}